'use strict';

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');

Object.defineProperty(exports, '__esModule', {
    value: true,
});
exports['default'] = void 0;

var _react = _interopRequireDefault(require('react'));

var _lodash = _interopRequireDefault(require('lodash'));

var _reactComponents = require('../../../react-components');

var _MultiInput = _interopRequireDefault(require('./MultiInput'));

var setFacetValue = function setFacetValue(_ref) {
    var options = _ref.options,
        subFilter = _ref.subFilter,
        setSubFilters = _ref.setSubFilters,
        subFilters = _ref.subFilters,
        index = _ref.index,
        value = _ref.value;
    var facetValue;

    if (!value && !subFilter.value && !subFilter.placeholder) {
        if (subFilter.required) {
            subFilters[index] = options[0];
            setSubFilters(subFilters);
        }

        return options[0];
    }

    options.forEach(function(option) {
        if (option.value === subFilter.value) facetValue = option;
    });
    return facetValue;
};

var setSelectFields = function setSelectFields(_ref2) {
    var curCat = _ref2.curCat,
        subFilter = _ref2.subFilter,
        isMultiSelect = _ref2.isMultiSelect,
        setSubFilters = _ref2.setSubFilters,
        index = _ref2.index,
        subFilters = _ref2.subFilters,
        value = _ref2.value;
    var multiSelectOptions, selectOptions, facetValue;

    if (curCat && curCat.subFilters) {
        if (isMultiSelect) {
            multiSelectOptions = curCat.subFilters;
            var allOptions = [];
            multiSelectOptions.forEach(function(section) {
                allOptions = allOptions.concat(section.options);
            });
            facetValue = setFacetValue({
                options: allOptions,
                subFilter: subFilter,
                setSubFilters: setSubFilters,
                index: index,
                subFilters: subFilters,
                value: value,
            });
        } else {
            selectOptions = subFilter.options;
            facetValue = setFacetValue({
                options: selectOptions,
                subFilter: subFilter,
                setSubFilters: setSubFilters,
                index: index,
                subFilters: subFilters,
                value: value,
            });
        }
    }

    return {
        multiSelectOptions: multiSelectOptions,
        selectOptions: selectOptions,
        facetValue: facetValue,
    };
};

var SubFilter = function SubFilter(_ref3) {
    var curCat = _ref3.curCat,
        subFilter = _ref3.subFilter,
        _onChange = _ref3.onChange,
        isMultiSelect = _ref3.isMultiSelect,
        value = _ref3.value,
        setSubFilters = _ref3.setSubFilters,
        index = _ref3.index,
        subFilters = _ref3.subFilters,
        error = _ref3.error;

    if (subFilter && subFilter.type) {
        var composition = subFilter.type.composition;

        switch (subFilter.type.value) {
            case 'multiInput':
                return /*#__PURE__*/ _react['default'].createElement(_MultiInput['default'], {
                    error: error,
                    value: value,
                    composition: composition,
                    onChange: function onChange(val) {
                        return _onChange(val);
                    },
                    subFilter: subFilter,
                });

            default: {
                var _setSelectFields = setSelectFields({
                        curCat: curCat,
                        subFilter: subFilter,
                        isMultiSelect: isMultiSelect,
                        setSubFilters: setSubFilters,
                        index: index,
                        subFilters: subFilters,
                        value: value,
                    }),
                    multiSelectOptions = _setSelectFields.multiSelectOptions,
                    selectOptions = _setSelectFields.selectOptions,
                    facetValue = _setSelectFields.facetValue;

                return /*#__PURE__*/ _react['default'].createElement(_reactComponents.SelectField, {
                    value: value || facetValue,
                    selectOptions: !multiSelectOptions && selectOptions,
                    multiSelectOptions: !selectOptions && multiSelectOptions,
                    name: 'value',
                    onChange: function onChange(value) {
                        return _onChange(value);
                    },
                });
            }
        }
    } else {
        var _setSelectFields2 = setSelectFields({
                curCat: curCat,
                subFilter: subFilter,
                isMultiSelect: isMultiSelect,
                setSubFilters: setSubFilters,
                index: index,
                subFilters: subFilters,
                value: value,
            }),
            _multiSelectOptions = _setSelectFields2.multiSelectOptions,
            _selectOptions = _setSelectFields2.selectOptions,
            _facetValue = _setSelectFields2.facetValue;

        return /*#__PURE__*/ _react['default'].createElement(_reactComponents.SelectField, {
            placeholder: subFilter.placeholder,
            value: value || _facetValue,
            selectOptions: !_multiSelectOptions && _selectOptions,
            multiSelectOptions: !_selectOptions && _multiSelectOptions,
            name: 'value',
            onChange: function onChange(value) {
                return _onChange(value);
            },
        });
    }
};

var _default = SubFilter;
exports['default'] = _default;
